import * as Axios from '../api/axios';

const notify = function (dispatch, errorData, type) {
  dispatch({
    type: type || 'ERROR',
    payload: errorData,
  });
  return Promise.reject(errorData);
};

export function signIn(data) {
  return (dispatch) => {
    return Axios.signIn(data).then((resData) => {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: resData,
      });
    }, (error) => {
      notify(dispatch, { error }, 'LOGIN_FAILED');
    });
  };
}

export function logout() {
  return (dispatch) => {
    dispatch({
      type: 'LOGOUT',
    });
  };
}

export function getData() {
  return (dispatch) => {
    dispatch({
      type: 'INITIATE',
    });

    return Axios.getData().then((data) => {
      dispatch({
        type: 'SUCCESS',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function setPlan(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'PLAN_INSERTION',
    });

    return Axios.setPlan(inputData).then((data) => {
      dispatch({
        type: 'PLAN_INSERTED',
        payload: { data },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getPlans() {
  return (dispatch) => {
    dispatch({
      type: 'PLANS_FETCHING',
    });

    return Axios.getPlan().then((data) => {
      dispatch({
        type: 'PLANS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getUserPlans(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'PLAN_ASSIGNMENT_FETCHING',
    });

    return Axios.getUserPlan(inputData).then((data) => {
      dispatch({
        type: 'PLAN_ASSIGNMENT_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getPracticeExercises() {
  return (dispatch) => {
    dispatch({
      type: 'PRACTICEEXERCISE_FETCHING',
    });

    return Axios.getPracticeExercises().then((data) => {
      dispatch({
        type: 'PRACTICEEXERCISE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getQuizes() {
  return (dispatch) => {
    dispatch({
      type: 'QUIZ_FETCHING',
    });

    return Axios.getQuizes().then((data) => {
      dispatch({
        type: 'QUIZ_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getAssessments() {
  return (dispatch) => {
    dispatch({
      type: 'ASSESSMENT_FETCHING',
    });

    return Axios.getAssessments().then((data) => {
      dispatch({
        type: 'ASSESSMENT_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getTaskTypes() {
  return (dispatch) => {
    dispatch({
      type: 'TASKTYPES_FETCHING',
    });

    return Axios.getTaskTypes().then((data) => {
      dispatch({
        type: 'TASKTYPES_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getLearnExercises() {
  return (dispatch) => {
    dispatch({
      type: 'LEARNEXERCISE_FETCHING',
    });

    return Axios.getLearnExercises().then((data) => {
      dispatch({
        type: 'LEARNEXERCISE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getVideoExercises() {
  return (dispatch) => {
    dispatch({
      type: 'VIDEO_EXERCISE_FETCHING',
    });

    return Axios.getVideoExercises().then((data) => {
      dispatch({
        type: 'VIDEO_EXERCISE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getVideoTypeExercises() {
  return (dispatch) => {
    dispatch({
      type: 'VIDEO_TYPE_EXERCISE_FETCHING',
    });

    return Axios.getVideoTypeExercises().then((data) => {
      dispatch({
        type: 'VIDEO_TYPE_EXERCISE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getVideoUrlTypeExercises() {
  return (dispatch) => {
    dispatch({
      type: 'VIDEO_URL_TYPE_EXERCISE_FETCHING',
    });

    return Axios.getVideoUrlTypeExercises().then((data) => {
      dispatch({
        type: 'VIDEO_URL_TYPE_EXERCISE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function insertOrUpdateVideoExercise(data) {
  return (dispatch) => {
    dispatch({
      type: 'VIDEO_EXERCISE_ADDING',
    });

    return Axios.insertOrUpdateVideoExercise(data).then((resData) => {
      dispatch({
        type: 'VIDEO_EXERCISE_ADDED',
        payload: {
          data: resData,
        },
      });
    }, (error) => {
      return notify(dispatch, { error });
    });
  };
}

export function deleteVideoExercise(data) {
  return (dispatch) => {
    dispatch({
      type: 'VIDEO_EXERCISE_DELETING',
    });

    return Axios.deleteVideoExercise(data).then((resData) => {
      dispatch({
        type: 'VIDEO_EXERCISE_DELETED',
        payload: {
          data: resData,
        },
      });
    }, (error) => {
      return notify(dispatch, { error });
    });
  };
}

export function addTask(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_ADDING',
    });

    return Axios.addTask(inputData).then((data) => {
      dispatch({
        type: 'TASK_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addTasks(tasks) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_ADDING',
    });

    return Axios.addTasks(tasks).then((data) => {
      dispatch({
        type: 'TASK_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchCompletedTasks(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'COMPLETED_TASKS_FETCHING',
    });

    return Axios.fetchCompletedTasks(inputData).then((data) => {
      dispatch({
        type: 'COMPLETED_TASKS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addTaskTemplate(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_TEMPLATE_ADDING',
    });

    return Axios.addTaskTemplate(inputData).then((data) => {
      dispatch({
        type: 'TASK_TEMPLATE_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function editTaskTemplate(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_TEMPLATE_UPDATING',
    });

    return Axios.editTaskTemplate(inputData).then((data) => {
      dispatch({
        type: 'TASK_TEMPLATE_UPDATED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchTaskTemplates() {
  return (dispatch) => {
    dispatch({
      type: 'TASK_TEMPLATE_FETCHING',
    });

    return Axios.fetchTaskTemplates().then((data) => {
      dispatch({
        type: 'TASK_TEMPLATE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchTaskTemplatePages(reqData) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_TEMPLATE_PAGE_FETCHING',
    });

    return Axios.fetchTaskTemplatePages(reqData).then((data) => {
      dispatch({
        type: 'TASK_TEMPLATE_PAGE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function deleteTaskTemplate(reqData) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_TEMPLATE_DELETING',
    });

    return Axios.deleteTaskTemplate(reqData).then((data) => {
      dispatch({
        type: 'TASK_TEMPLATE_DELETED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addMultiTemplate(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'MULTI_TEMPLATE_ADDING',
    });

    return Axios.addMultiTemplate(inputData).then((data) => {
      dispatch({
        type: 'MULTI_TEMPLATE_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function editMultiTemplate(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'MULTI_TEMPLATE_ADDING',
    });

    return Axios.editMultiTemplate(inputData).then((data) => {
      dispatch({
        type: 'MULTI_TEMPLATE_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchMultiTemplates() {
  return (dispatch) => {
    dispatch({
      type: 'MULTI_TEMPLATE_FETCHING',
    });

    return Axios.fetchMultiTemplates().then((data) => {
      dispatch({
        type: 'MULTI_TEMPLATE_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchTasks(planId) {
  return (dispatch) => {
    dispatch({
      type: 'TASKS_FETCHING',
    });

    return Axios.fetchTasks(planId).then((data) => {
      dispatch({
        type: 'TASKS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchSingleDayTasks(data) {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_SINGLE_DAY_TASK',
      day: data.day,
    });

    return Axios.fetchSingleDayTasks(data).then((resData) => {
      dispatch({
        type: 'FETCHED_SINGLE_DAY_TASK',
        payload: {
          data: resData,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getPlanDays(data) {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_DAYS',
    });

    return Axios.getPlanDays(data).then((resData) => {
      dispatch({
        type: 'FETCHED_DAYS',
        payload: {
          data: resData,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function updateTasks(data) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATING_TASKS',
    });

    return Axios.updateTasks(data).then((resData) => {
      dispatch({
        type: 'UPDATED_TASKS',
        payload: {
          resData,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function updateTask(task) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_UPDATING',
    });

    return Axios.updateTask(task).then((data) => {
      dispatch({
        type: 'TASK_UPDATED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchUser(field) {
  return (dispatch) => {
    dispatch({
      type: 'USER_FETCHING',
    });

    return Axios.fetchUser(field).then((data) => {
      dispatch({
        type: 'USER_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchTherapists(field) {
  return (dispatch) => {
    dispatch({
      type: 'THERAPISTS_FETCHING',
    });

    return Axios.fetchTherapists(field).then((data) => {
      dispatch({
        type: 'THERAPISTS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getAllTherapists() {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_THERAPIST',
    });

    return Axios.getAllTherapists().then((data) => {
      dispatch({
        type: 'FETCHED_THERAPIST',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchAssignedUsers(data) {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_ASSIGNED_USERS',
    });

    return Axios.fetchAssignedUsers(data).then((res) => {
      dispatch({
        type: 'FETCHED_ASSIGNED_USERS',
        payload: {
          data: res,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function resetTherapists() {
  return (dispatch) => {
    return dispatch({
      type: 'THERAPISTS_RESET',
      payload: {
        data: null,
      },
    });
  };
}

export function assignUsersToTherapists(field) {
  return (dispatch) => {
    dispatch({
      type: 'THERAPISTS_ASSIGNING',
    });

    return Axios.assignUsersToTherapists(field).then(() => {
      dispatch({
        type: 'THERAPISTS_ASSIGNED',
        payload: {
          data: null,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function fetchAllUsers() {
  return (dispatch) => {
    dispatch({
      type: 'USERS_FETCHING',
    });

    return Axios.fetchAllUsers().then((data) => {
      dispatch({
        type: 'USERS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function assignPlan(userId, planId) {
  return (dispatch) => {
    dispatch({
      type: 'PLAN_ASSIGNING',
    });

    return Axios.assignPlan(userId, planId).then((data) => {
      dispatch({
        type: 'PLAN_ASSIGNED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function deleteTask(taskId) {
  return (dispatch) => {
    dispatch({
      type: 'TASK_DELETING',
    });

    return Axios.deleteTask(taskId).then((data) => {
      dispatch({
        type: 'TASK_DELETED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addCallType(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'ADDING_CALL_TYPE',
    });

    return Axios.addCallType(inputData).then((data) => {
      dispatch({
        type: 'CALL_TYPE_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function editCallType(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'EDITING_CALL_TYPE',
    });

    return Axios.editCallType(inputData).then((data) => {
      dispatch({
        type: 'CALL_TYPE_EDITED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getCallTypes() {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_CALL_TYPES',
    });

    return Axios.getCallTypes().then((data) => {
      dispatch({
        type: 'CALL_TYPES_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addCallSlot(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'ADDING_CALL_SLOT',
    });

    return Axios.addCallSlot(inputData).then((data) => {
      dispatch({
        type: 'CALL_SLOT_ADDED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function addDashboardUser(inputData) {
  return (dispatch) => {
    return Axios.addDashboardUser(inputData).then(() => {
      // dispatch({
      //   type: 'DASHBOARD_USER_ADDED',
      //   payload: {
      //     data,
      //   },
      // });
    }, (error) => {
      notify(dispatch, { error });
      throw new Error(error.response.data.errors[0].msg);
    });
  };
}

export const fetchAllTherapist = () => {
  return async (dispatch) => {
    try {
      const data = await Axios.fetchAllTherapist();
      dispatch({
        type: 'ALL_THERAPIST',
        payload: data,
      });
    } catch (error) {
      notify(dispatch, { error });
      throw new Error(error.response.data.errors[0].msg);
    }
  };
};

export const addTherapist = (data) => {
  return async (dispatch) => {
    try {
      await Axios.addTherapist(data);
    } catch (error) {
      notify(dispatch, { error });
      throw new Error(error.response.data.errors[0].msg);
    }
  };
};

export const updateTherapist = (data) => {
  return async (dispatch) => {
    try {
      await Axios.updateTherapist(data);
    } catch (error) {
      notify(dispatch, { error });
      throw new Error(error.response.data.errors[0].msg);
    }
  };
};

export function editCallSlot(inputData) {
  return (dispatch) => {
    dispatch({
      type: 'EDITING_CALL_SLOT',
    });

    return Axios.editCallSlot(inputData).then((data) => {
      dispatch({
        type: 'CALL_SLOT_EDITED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getCallSlots() {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_CALL_SLOTS',
    });

    return Axios.getCallSlots().then((data) => {
      dispatch({
        type: 'CALL_SLOTS_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function deleteCallSlot(id) {
  return (dispatch) => {
    dispatch({
      type: 'DELETING_CALL_SLOTS',
    });

    return Axios.deleteCallSlot(id).then((data) => {
      dispatch({
        type: 'CALL_SLOTS_DELETED',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getModerators() {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_MODERATOR',
    });

    return Axios.getModerators().then((data) => {
      dispatch({
        type: 'FETCHED_MODERATOR',
        payload: {
          data,
        },
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
}

export function getOffers() {
  return (dispatch) => {
    dispatch({
      type: 'OFFER_FETCHING',
    });

    return Axios.getOffers().then((data) => {
      dispatch({
        type: 'OFFER_FETCHED',
        payload: {
          data,
        },
      });
    }, (error) => {
      dispatch({ type: 'LOADING_OFF' });
      notify(dispatch, { error });
    });
  };
}

export function updateOffer(data) {
  return (dispatch) => {
    dispatch({
      type: 'OFFER_FETCHING',
    });

    return Axios.updateOffer(data).then(() => {
      dispatch({ type: 'LOADING_OFF' });
    }, (error) => {
      dispatch({ type: 'LOADING_OFF' });
      notify(dispatch, { error });
    });
  };
}

export function createOffer(data) {
  return (dispatch) => {
    dispatch({
      type: 'OFFER_FETCHING',
    });

    return Axios.createOffer(data).then(() => {
      dispatch({ type: 'LOADING_OFF' });
    }, (error) => {
      dispatch({ type: 'LOADING_OFF' });
      notify(dispatch, { error });
    });
  };
}

export function syncTasks() {
  return () => {
    return Axios.syncTasks();
  };
}
